import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { SlipState } from '@bpos/v1/my-bets';
import { Sitecore, SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { MyBetsBetSlip } from '../../../my-bets-base/models/my-bets-viewmodels';
import { PendingPayoutInfoService } from '../../services/pending-payout-info.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ms-my-bets-outcome-badge',
    styleUrl: 'outcome-badge.component.scss',
    template: `
        <div class="my-bets-outcome-badge {{ notificationClassName }}">{{ outcome }}</div>
        <span *ngIf="betslip.isPendingPayout" [class]="infoIconClassName" (click)="infoIconClick($event)"></span>
    `,
})
export class MyBetsOutcomeBadgeComponent {
    @Input() betslip: MyBetsBetSlip;
    @HostBinding('class.pending-payout') get pendingPayout(): boolean {
        return this.betslip.isPendingPayout;
    }

    infoIconActive = false;

    constructor(
        private sitecore: Sitecore,
        private sitecoreMyBets: SitecoreMyBetsConfig,
        private pendingPayoutInfoService: PendingPayoutInfoService,
    ) {}

    get outcome(): string {
        if (this.betslip.isPendingPayout) {
            return this.sitecore.earlyPayoutV2.PendingPayout;
        } else if (this.betslip.isCachedOut) {
            return this.sitecore.earlyPayoutV2.PaidOut;
        } else if (this.betslip.isRefunded) {
            return this.sitecoreMyBets.myBets.REFUNDED;
        } else if (this.betslip.isRecoveringAfterEditBet) {
            return this.sitecoreMyBets.myBets.EditBetError;
        } else {
            return this.sitecoreMyBets.myBets[this.betslip.state.toUpperCase()];
        }
    }

    get notificationClassName(): string {
        if (this.betslip.isPendingPayout) {
            return 'badge-pending-payout';
        }
        if (this.betslip.isCachedOut) {
            return 'badge-cachedout';
        }
        if (this.betslip.isRefunded) {
            return 'badge-refunded';
        }
        if (this.betslip.isRecoveringAfterEditBet) {
            return 'badge-error';
        }
        switch (this.betslip.state) {
            case SlipState.Open:
                return 'badge-open';
            case SlipState.Canceled:
                return 'badge-cancelled';
            case SlipState.Won:
                return 'badge-won';
            case SlipState.Lost:
                return 'badge-lost';
        }

        return '';
    }

    get infoIconClassName(): string {
        return this.infoIconActive ? 'theme-info-i' : 'theme-info';
    }

    infoIconClick(event: MouseEvent): void {
        event.stopPropagation();
        this.infoIconActive = !this.infoIconActive;
        this.pendingPayoutInfoService.visible = { id: this.betslip.betslipRealId, visible: this.infoIconActive };
    }
}
